var render, staticRenderFns
import script from "./PriceConfigurator.vue?vue&type=script&lang=js&"
export * from "./PriceConfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('492895fc')) {
      api.createRecord('492895fc', component.options)
    } else {
      api.reload('492895fc', component.options)
    }
    
  }
}
component.options.__file = "src/js/components/PriceConfigurator.vue"
export default component.exports